<mat-progress-bar
  id="bar-loader"
  mode="determinate"
  [value]="progress"
  [hidden]="isHidden"></mat-progress-bar>
